import { render, staticRenderFns } from "./SelectFileEstrutura.vue?vue&type=template&id=2cfcf29c"
import script from "./SelectFileEstrutura.vue?vue&type=script&lang=js"
export * from "./SelectFileEstrutura.vue?vue&type=script&lang=js"
import style0 from "./SelectFileEstrutura.vue?vue&type=style&index=0&id=2cfcf29c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports